import { AppBar, Divider } from '@mui/material';
import './AppBar.scss';

/** @param {import('@mui/material').AppBarProps} param0 */
const CoreAppBar = ({ children, className, ...props }) => (
    <AppBar
        className={`core--app-bar ${className || ''}`}
        position="sticky"
        {...props}
    >
        {children}
        <Divider />
    </AppBar>
);

export default CoreAppBar;
